import Vue from 'vue'
import App from './App.vue'

import './assets/styles/index.css';
import Router from './routes';
import Axios from 'axios';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-loaders/dist/vue-loaders.css';
import VueLoaders from 'vue-loaders';

import moment from 'moment';

Vue.config.productionTip = false

Axios.defaults.baseURL = 'https://gciosaapi.gemsonline.org';

// Axios.defaults.baseURL = 'http://localhost:8000';



Vue.use(VueSweetalert2);

Vue.use(VueLoaders);

Vue.filter('formatDate', function(value){
    if(value){
        return moment(String(value)).format('MMMM Do, YYYY')
    }
});

Vue.filter('formatDateSlash', function(value){
    if(value){
        return moment(String(value)).format('DD/MM/YYYY')
    }
});

new Vue({
  router: Router,
  render: h => h(App),

}).$mount('#app')
